import React from 'react';
import {Form} from 'semantic-ui-react';
import GroupForm from './GroupForm';

const ShowInformationVehicle = ({vehicle}) => {
  const {katashiki, modelDescription, modelYear, color, transmition, traction, gasType} = vehicle;
  return (
    <Form>
      <div className="tcc-wrapper">
        <GroupForm
          text1={katashiki}
          text2={modelDescription}
          text3={modelYear}
          label1="Katashiki"
          label2="Modelo"
          label3="Año Modelo"
        />
        <GroupForm
          text1={color}
          text2={transmition}
          text3={traction}
          label1="Color"
          label2="Transmisión"
          label3="Tracción"
        />
        <Form.Group widths={3}>
          <Form.Input value={gasType} fluid label={'Combustible'} placeholder={'Combustible'} disabled/>
        </Form.Group>
      </div>
    </Form>
  );
};

export default ShowInformationVehicle;
